import { TCardOperationDateItem } from '@app/api/giftCards/gift-cards.service';

export type TRecentOperationItem = {
  type: 'activation' | 'sale' | 'return' | 'refund';
  cardName: string;
  image?: string;
  caption: string;
  value?: string;
};

export type TRecentOperationDate = {
  date: string;
  items: TRecentOperationItem[];
};

export function mapOperationsData(arr: TCardOperationDateItem[], lang: string): TRecentOperationDate[] {
  const returnedArr: TRecentOperationDate[] = [];
  arr.forEach((element) => {
    const obj = {
      date: element.date,
      items: [] as TRecentOperationItem[],
    };
    element.operations.forEach((operation) => {
      if (operation.operationType) {
        obj.items.push({
          type: operation.operationType,
          cardName: operation.card.product.name[lang],
          image: operation.card.product.imageUrl,
          caption: operation.operationType,
          value: (operation.operationDetail.value / 100).toString(),
        });
      }
    });
    returnedArr.push(obj);
  });
  return returnedArr;
}

export function limitOperationsData(
  data: TRecentOperationDate[],
  maxTotalItems = 4,
  maxParentItems = 4,
): TRecentOperationDate[] {
  const result: TRecentOperationDate[] = [];
  let remainingItems = maxTotalItems;

  // eslint-disable-next-line no-restricted-syntax
  for (const dateItem of data) {
    if (result.length >= maxParentItems || remainingItems <= 0) break;

    const limitedItem: TRecentOperationDate = {
      date: dateItem.date,
      items: [],
    };

    // Берем либо все элементы, либо столько, сколько осталось (но не больше, чем есть)
    const itemsToTake = Math.min(dateItem.items.length, remainingItems);
    limitedItem.items = dateItem.items.slice(0, itemsToTake);
    remainingItems -= itemsToTake;

    result.push(limitedItem);
  }

  return result;
}
